import { ChangeDetectorRef, Component, Input, OnInit, ViewChild, inject } from '@angular/core';
import { IonInfiniteScroll, ModalController } from '@ionic/angular';
import { Files } from 'package-types';
import { Product } from 'src/app/models/Product';
import { ProductService } from 'src/app/services/product/product.service';

@Component({
  selector: 'app-select-product-modal',
  templateUrl: './select-product-modal.component.html',
  styleUrls: ['./select-product-modal.component.scss'],
  standalone: false,
})
export class SelectProductModalComponent implements OnInit {
  private modalCtrl = inject(ModalController);
  productService = inject(ProductService);
  private cdRef = inject(ChangeDetectorRef);


  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;

  @Input() merchantId;

  skip = 0;
  limit = 15;
  isSearch = false;
  debounce;
  filteredProducts: { imagesLinks: Files.Images.IdDimensionsLinks; products: Product[] };

  async ngOnInit() {
    this.productService.resetPagination();
    await this.productService.getPaginatedProducts(
      { skip: this.skip, limit: this.limit },
      this.infiniteScroll,
      this.merchantId,
    );
    this.cdRef.detectChanges();
  }

  async doInfinite() {
    this.skip += this.limit;
    await this.productService.getPaginatedProducts(
      { skip: this.skip, limit: this.limit },
      this.infiniteScroll,
      this.merchantId,
    );
    this.cdRef.detectChanges();
  }

  selectProduct(product, image) {
    this.modalCtrl.dismiss({ productData: { product, image } });
  }

  async back() {
    await this.modalCtrl.dismiss();
  }

  closeSearch() {
    this.isSearch = false;
  }
  async search(productName) {
    clearTimeout(this.debounce);
    if (productName.length === 0) {
      this.closeSearch();
      return;
    }
    this.debounce = setTimeout(async () => {
      this.isSearch = true;
      this.filteredProducts = await this.productService.getFilteredProducts({
        skip: 0,
        limit: 999,
        productName,
        merchantId: this.merchantId,
      });
      this.cdRef.detectChanges();
    }, 300);
  }
}
